/******/ (() => { // webpackBootstrap
  var __webpack_exports__ = {};
  /*!*****************************!*\
    !*** ./src/js/video-pdp.js ***!
    \*****************************/
  document.addEventListener('DOMContentLoaded', function () {

    let videoTop = document.querySelector('.lb-product-header-video-top');

    if (videoTop) {

      let videoInner = document.getElementById('lb-product-header-video-inner');
      let videoElement = videoInner.querySelector('video');
      let videoOpener = document.getElementById('lb-product-header-video-opener');
      let closeButton = document.getElementById('video-close');

      videoElement.classList.add('display-video');

      function toggleVideo(play) {
        videoInner.classList.toggle('video-active', play);

        if (play) {
          videoElement.play();
          videoElement.loop = true;
        } else {
          videoElement.pause();
        }

      }

      videoOpener.addEventListener('click', function () {
        toggleVideo(true);
      });

      videoInner.addEventListener('click', function (event) {

        if (event.target === closeButton || event.target === videoInner) {
          toggleVideo(false);
        }

      });

      closeButton.addEventListener('click', function () {
        toggleVideo(false);
      });

    }

  });
  /******/ })()
  ;
  